import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

/**
 * Componente FormItem
 *
 * Un contenedor estilizado basado en Paper de MUI, utilizado para envolver elementos de formularios
 * y mantener una presentación consistente.
 *
 * @component
 * @example
 * <FormItem>Contenido</FormItem>
 */

export const FormItem = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

export default FormItem;
